import type { ILanguage, ISocial } from '@ts/interfaces/app.interfaces';
import { ELanguage } from '@ts/enums/app.enum';

export default defineAppConfig({
    socials: [
        {
            type: 'tg',
            link: 'https://t.me/lbr_ru/',
        },
        {
            type: 'tiktok',
            link: 'https://www.tiktok.com/@lbr.ru/',
        },
        {
            type: 'vk',
            link: 'https://vk.com/lbragro',
        },
        {
            type: 'youtube',
            link: 'https://www.youtube.com/user/LBRAgromarket/',
        },
        {
            type: 'ok',
            link: 'https://ok.ru/group/53776660365514',
        },
    ] as ISocial[],
    languages: [
        {
            id: ELanguage.RU,
            slug: 'rus',
            name: 'Русский',
        },
        {
            id: ELanguage.EN,
            slug: 'eng',
            name: 'English',
        },
    ] as ILanguage[],
    noRouteLink: '/in-developing' as string,
})
